import React from "react";
import {ExternalLink} from "components/Link";
import logo888White from "apps/GB/assets/img/888logosWhite.svg";
import bwin from "apps/DE/assets/img/bwin_dark.png";
import paddypower from "apps/GB/assets/img/paddypower_dark.png";
import styled from "styled-components";
import {SYNDICATE_COUNTRY} from "modules/constants";

const Logo = styled.img`
	width: 26px;
`;

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	align-self: center;
	height: 100%;
	img {
		height: 24px;
	}
`;

export const Betting888LogoWhite: React.FC = (props) => (
	<ExternalLink href="https://www.888sport.com/" {...props}>
		<Logo src={logo888White} alt="888 sport" />
	</ExternalLink>
);

export const BettingLogo: React.FC = (props) => {
	const sponsor =
		{
			DE: <img src={bwin} alt="" />,
			GB: <img src={paddypower} alt="" />,
		}[SYNDICATE_COUNTRY] || null;

	if (!sponsor) {
		return null;
	}
	return <Wrapper>{sponsor}</Wrapper>;
};
